import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/providers/Store/model/store';

const getOrderState = (state: RootState) => state.orders;

export const orderSelectors = {
  getOrders: createSelector(getOrderState, (state) => state.orders),
  getOrdersLoading: createSelector(getOrderState, (state) => state.isLoading),
  getOrderDetail: createSelector(getOrderState, (state) => state.orderDetail.data),
  getOrderDetailLoading: createSelector(getOrderState, (state) => state.orderDetail.isLoading),
};
